import {CommonModule} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatDialogModule} from '@angular/material/dialog';
import {RouterModule} from '@angular/router';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {IsupplierSharedModule} from '@i-supplier/angular-shared-module';
import {NgSelectModule} from '@ng-select/ng-select';
import {MissingTranslationHandler, TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {AlertModule} from 'ngx-bootstrap/alert';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {ModalModule} from 'ngx-bootstrap/modal';
import {TimepickerModule} from 'ngx-bootstrap/timepicker';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {NgxFileDropModule} from 'ngx-file-drop';
import {NgxIntlTelInputModule} from 'ngx-intl-tel-input-gg';
import {NgxSpinnerModule} from 'ngx-spinner';
import {ToastrModule} from 'ngx-toastr';
import {environment} from '../../assets/environments/environment';
import {HttpLoaderFactory} from '../app.module';
import {ActivityAreaDropdownComponent} from './components/activity-area-dropdown/activity-area-dropdown.component';
import {ActivityReportModalComponent} from './components/activity-report-modal/activity-report-modal.component';
import {AlertComponent} from './components/alert/alert.component';
import {CguModalComponent} from './components/cgu-modal/cgu-modal.component';
import {ElectronicInvoicingInfoModalComponent} from './components/electronic-invoicing-info-modal/electronic-invoicing-info-modal.component';
import {CounterComponent} from './components/counter/counter.component';
import {CurrencyInputComponent} from './components/currency-input/currency-input.component';
import {FileDropComponent} from './components/file-drop/file-drop.component';
import {FileDrop2Component} from './components/file-drop2/file-drop.component';
import {InfoLineComponent} from './components/info-line/info-line.component';
import {ListContentComponent} from './components/list-content/list-content.component';
import {ModalConfirmComponent} from './components/modal-confirm/modal-confirm.component';

import {ModalIdleWarningComponent} from './components/modal-idle-warning/modal-idle-warning.component';
import {NoContentComponent} from './components/no-content/no-content.component';
import {NoDataComponent} from './components/no-data/no-data.component';
import {PageMenuComponent} from './components/page-menu/page-menu.component';
import {PlusMinusInputComponent} from './components/plus-minus-input/plus-minus-input.component';
import {SpinnerComponent} from './components/spinner/spinner.component';
import {UploadModalComponent} from './components/upload-modal/upload-modal.component';
import {VerticalPageMenuComponent} from './components/vertical-page-menu/vertical-page-menu.component';
import {FormFeedbackComponent} from './form-feedback/form-feedback.component';
import {OnlyNumbersDirective} from './only-number/only-numbers.directive';
import {AddressPipe} from './pipes/address.pipe';
import {BooleanFormatPipe} from './pipes/boolean-format.pipe';
import {CurrencyFormatPipe} from './pipes/currency-format.pipe';
import {DefaultPipe} from './pipes/default.pipe';
import {EllipsisPipe} from './pipes/ellipsis.pipe';
import {LocalizedCurrencyPipe} from './pipes/localized-currency.pipe';
import {LocalizedDatePipe} from './pipes/localized-date/localized-date.pipe';
import {StatusPipe} from './pipes/status.pipe';
import { SafePipe } from './pipes/safe.pipe';
import {SentryMissingTranslationHandler} from './sentry-missing-translation-handler';

@NgModule({
  declarations: [
    FormFeedbackComponent,
    AlertComponent,
    StatusPipe,
    EllipsisPipe,
    AddressPipe,
    BooleanFormatPipe,
    DefaultPipe,
    CurrencyFormatPipe,
    ListContentComponent,
    SpinnerComponent,
    PageMenuComponent,
    CounterComponent,
    VerticalPageMenuComponent,
    FileDropComponent,
    FileDrop2Component,
    NoDataComponent,
    NoContentComponent,
    LocalizedCurrencyPipe,
    ModalConfirmComponent,
    ActivityReportModalComponent,
    UploadModalComponent,
    PlusMinusInputComponent,
    CurrencyInputComponent,
    InfoLineComponent,
    ModalIdleWarningComponent,
    SafePipe,
    OnlyNumbersDirective,
    LocalizedDatePipe,
    CguModalComponent,
    ElectronicInvoicingInfoModalComponent,
    ActivityAreaDropdownComponent
  ],
  exports: [
    FormFeedbackComponent,
    ToastrModule,
    AlertComponent,
    StatusPipe,
    DefaultPipe,
    EllipsisPipe,
    AddressPipe,
    SafePipe,
    BooleanFormatPipe,
    CurrencyFormatPipe,
    PageMenuComponent,
    ListContentComponent,
    SpinnerComponent,
    NgxIntlTelInputModule,
    TooltipModule,
    ModalModule,
    CounterComponent,
    CurrencyInputComponent,
    ModalModule, CounterComponent,
    VerticalPageMenuComponent,
    FileDropComponent,
    NoDataComponent,
    LocalizedCurrencyPipe,
    NoContentComponent,
    ModalConfirmComponent,
    InfoLineComponent,
    FileDrop2Component,
    OnlyNumbersDirective,
    FontAwesomeModule,
    ModalIdleWarningComponent,
    LocalizedDatePipe,
    ActivityAreaDropdownComponent,
    IsupplierSharedModule,
    SafePipe
  ],
  imports: [
    CommonModule,
    NgSelectModule,
    AlertModule.forRoot(),
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    TranslateModule.forChild({
      missingTranslationHandler: {provide: MissingTranslationHandler, useClass: SentryMissingTranslationHandler},
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: false,
    }),
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right',
      timeOut: 5000,
      preventDuplicates: false,
      closeButton: true,
      progressBar: true,
      tapToDismiss: false,
      extendedTimeOut: 5000
    }),
    RouterModule,
    FormsModule,
    NgxFileDropModule,
    PdfViewerModule,
    BsDatepickerModule.forRoot(),
    NgxSpinnerModule,
    ReactiveFormsModule,
    MatDialogModule,
    TimepickerModule,
    FontAwesomeModule,
    NgxIntlTelInputModule,
    IsupplierSharedModule.forRoot({
      api_root: environment.api_root
    })
  ]
})
export class SharedModule {}
